import type { RouteRecordRaw } from 'vue-router';

export default <RouteRecordRaw[]>[
  {
    path: 'shelters',
    name: 'shelters',
    component: () => import('./views/AdminShelters.view.vue'),
  },
  {
    path: 'cs-migration',
    name: 'cs-migration',
    component: () => import('./views/AdminCsMigration.view.vue'),
  },
  {
    path: 'case-animal-forms-migration',
    name: 'case-animal-forms-migration',
    component: () => import('./views/AdminCaseAnimalFormsMigration.view.vue'),
  },
  {
    path: 'bite-report-image-migration',
    name: 'bite-report-image-migration',
    component: () => import('./views/AdminBiteReportImageMigration.view.vue'),
  },
  {
    path: 'fs-activity-image-migration',
    name: 'fs-activity-image-migration',
    component: () => import('./views/AdminFieldServiceActivityImageMigration.view.vue'),
  },
  {
    path: 'people-custom-fields-migration',
    name: 'people-custom-fields-migration',
    component: () => import('./views/AdminPeopleCustomFieldsMigration.view.vue'),
  },
  {
    path: 'outcome-contracts-migration',
    name: 'outcome-contracts-migration',
    component: () => import('./views/AdminOutcomeContractsMigration.view.vue'),
  },
  {
    path: 'atlas-search-flags-migration',
    name: 'atlas-search-flags-migration',
    component: () => import('./views/AdminAtlasSearchFlagsMigration.view.vue'),
  },
];
